import { Dispatch } from 'redux';
import { POLICY_HISTORY_FAILED, POLICY_HISTORY_START, POLICY_HISTORY_SUCCESS } from './types';
import { ApiClient } from '../api.client';
import { ReduxStore } from '../payload-types';
import { LINKS } from '@trip-ux/constants';
import { map } from 'lodash';
import { interpolateTemplate } from '@trip-ux/common';

export const getPolicyHistory = (policyNumbers: string[]) => (
  dispatch: Dispatch,
  getState: () => ReduxStore,
  apiClient: ApiClient
): Promise<void> => {
  dispatch({ type: POLICY_HISTORY_START });

  return Promise.all(
    map(policyNumbers, policyNumber =>
      apiClient(dispatch, getState).get(interpolateTemplate(LINKS.POLICYHISTORY, { policyNumber }))
    )
  )
    .then(payload => {
      dispatch({ type: POLICY_HISTORY_SUCCESS, payload });
    })
    .catch(e => {
      dispatch({ type: POLICY_HISTORY_FAILED, payload: e });
    });
};
